<template>
  <div id="market-view-preview" class="market-view">
    <transition-group
      v-if="!checkIsMobile() && !checkIsTablet() && getPreview.length > 0"
      name="card-in-out"
    >
      <v-card
        class="tournament-card-preview"
        v-for="(object, index) in getPreview"
        :key="'getPreviewObject' + index"
      >
        <div class="progress-line-container">
          <v-progress-linear
            indeterminate
            color="primary darken-2"
            v-if="checkIfIsLoading(object) || getLoadingPreview === true"
          >
          </v-progress-linear>
        </div>

        <tournament-breadcrumb
          :object="object"
          :sport-path="sportPath"
          :category-path="categoryPath"
          :light="light"
          :breadcrumb-type="breadcrumbPrematchType"
          @remove-preview="removePreview"
        />

        <!-- todo move to a component market view odds group -->
        <v-row
          class="no-padding no-margin"
          v-if="
            getGroupMarketsForCategory(object).length > 0 &&
            getUseMarketOddsGroupV2 === 'default'
          "
        >
          <v-col
            cols="12"
            md="12"
            class="market-view-odds-group-container"
            id="container_group_markets_odds"
          >
            <v-col
              cols="2"
              class="market-view-odds-group-col"
              v-for="(marketGroup, index) in getGroupMarketsForCategory(object)"
              :key="'market_group_' + index"
              :class="index === 0 || index % 6 === 0 ? 'first' : ''"
            >
              <v-btn
                small
                tile
                class=""
                :class="
                  marketGroup._id === getMarketGroupActive(object)
                    ? 'group-odds-active'
                    : ''
                "
                depressed
                @click="showPreviewForFirstMarket(object, marketGroup, index)"
              >
                <span class="text-sport text-capitalize">
                  {{ getTranslatedGroupMarket(marketGroup) }}</span
                >
              </v-btn>
            </v-col>
          </v-col>
          <v-col cols="12" md="12" id="container_markets_odds">
            <div
              class="col-xs-6 col-sm-4 col-md-3 col-lg-3 col-xl-3 markets-button-container"
              v-if="
                isFirstGroupSelected(object.tournament.id) &&
                hideMainButtonOnPrematchShowcase === false
              "
            >
              <v-btn
                tile
                :class="
                  isMainMarketActive(object.tournament.id)
                    ? 'markets-odds-active'
                    : ''
                "
                link
                filter
                class="btn_market"
                @click="loadDefaultPreview(object)"
              >
                {{ $t('main') }}
              </v-btn>
            </div>

            <template v-if="showMore(object)">
              <div
                class="col-xs-6 col-sm-4 col-md-3 col-lg-3 col-xl-3 markets-button-container"
                v-for="(market, index) in getSpecifiersForTournament(
                  object.sport._id,
                  object.tournament
                )"
                :key="'market_specifier_' + index"
              >
                <v-btn
                  tile
                  :title="getTranslatedMarketName(market)"
                  class="btn_market"
                  v-bind:class="{
                    'markets-odds-active': isThisMarketActive(
                      object.tournament.id,
                      market.id
                    ),
                  }"
                  @click="
                    loadPreviewAndSelectThisMarketV2(
                      object.sport._id,
                      object.sport.id,
                      object.source,
                      object.tournament,
                      object.tournament.id,
                      market,
                      market.id,
                      index + 1,
                      null,
                      null,
                      false
                    )
                  "
                >
                  <span>
                    {{ getTranslatedMarketName(market) }}
                  </span>
                </v-btn>
              </div>
            </template>
            <template v-else>
              <div
                class="col-xs-6 col-sm-4 col-md-3 col-lg-3 col-xl-3 markets-button-container"
                v-for="(market, index) in getSpecifiersForTournament(
                  object.sport._id,
                  object.tournament
                ).slice(0, 12)"
                :key="'market_specifier_' + index"
              >
                <v-btn
                  tile
                  v-bind:class="{
                    'markets-odds-active': isThisMarketActive(
                      object.tournament.id,
                      market.id
                    ),
                  }"
                  @click="
                    loadPreviewAndSelectThisMarketV2(
                      object.sport._id,
                      object.sport.id,
                      object.source,
                      object.tournament,
                      object.tournament.id,
                      market,
                      market.id,
                      index + 1,
                      null,
                      null,
                      false
                    )
                  "
                  class="btn_market"
                  :title="getTranslatedMarketName(market)"
                >
                  <span>
                    {{ getTranslatedMarketName(market) }}
                  </span>
                </v-btn>
              </div>
            </template>
          </v-col>
          <v-col
            cols="12"
            md="12"
            class="showMoreMarketsContainer"
            v-if="
              getSpecifiersForTournament(object.sport._id, object.tournament)
                .length > 12
            "
          >
            <div class="d-flex">
              <span style="margin-left: auto" @click="toggleShowLess(object)">
                <span class="d-flex" style="cursor: pointer; font-size: 12px">
                  {{ !showMore(object) ? $t('showMore') : $t('showLess') }}
                  <div>
                    <v-icon
                      v-if="!showMore(object)"
                      class="arrow-down"
                      style="
                        font-size: 14px;
                        padding-left: 6px;
                        padding-bottom: 4px;
                      "
                      >mdi-arrow-down</v-icon
                    >
                    <v-icon
                      v-else
                      class="arrow-up"
                      style="
                        font-size: 14px;
                        padding-left: 6px;
                        padding-bottom: 4px;
                      "
                      >mdi-arrow-up</v-icon
                    >
                  </div>
                </span>
              </span>
            </div>
          </v-col>
        </v-row>

        <!--              todo verificare css MARKETGROUPV2-->
        <v-row
          class="no-padding no-margin"
          v-if="
            getGroupMarketsForCategory(object).length > 0 &&
            getUseMarketOddsGroupV2 === 'scrollable-1'
          "
        >
          <v-col cols="12" md="12" class="no-padding">
            <div
              class="market-view-odds-group-container v2"
              id="container_group_markets_odds"
            >
              <div
                class="market-view-odds-group-col"
                v-for="(marketGroup, index) in getGroupMarketsForCategory(
                  object
                )"
                :key="'market_group_' + index"
                :class="index === 0 || index % 6 === 0 ? 'first' : ''"
              >
                <v-btn
                  small
                  tile
                  class=""
                  :class="
                    marketGroup._id === getMarketGroupActive(object)
                      ? 'group-odds-active'
                      : ''
                  "
                  depressed
                  @click="showPreviewForFirstMarket(object, marketGroup, index)"
                >
                  <span class="text-sport text-capitalize">
                    {{ getTranslatedGroupMarket(marketGroup) }}</span
                  >
                </v-btn>
              </div>
            </div>
          </v-col>
          <v-col
            cols="12"
            md="12"
            id="container_markets_odds"
            class="container_markets_odds v2"
          >
            <div
              class="col-xs-6 col-sm-4 col-md-2 col-lg-2 col-xl-2 markets-button-container"
              v-if="
                isFirstGroupSelected(object.tournament.id) &&
                hideMainButtonOnPrematchShowcase === false
              "
            >
              <v-btn
                tile
                :class="
                  isMainMarketActive(object.tournament.id)
                    ? 'markets-odds-active'
                    : ''
                "
                link
                filter
                class="btn_market"
                @click="loadDefaultPreview(object)"
              >
                {{ $t('main') }}
              </v-btn>
            </div>

            <template v-if="showMore(object)">
              <div
                class="col-xs-6 col-sm-4 col-md-2 col-lg-2 col-xl-2 markets-button-container"
                v-for="(market, index) in getSpecifiersForTournament(
                  object.sport._id,
                  object.tournament
                )"
                :key="'market_specifier_' + index"
              >
                <v-btn
                  tile
                  :title="getTranslatedMarketName(market)"
                  class="btn_market"
                  v-bind:class="{
                    'markets-odds-active': isThisMarketActive(
                      object.tournament.id,
                      market.id
                    ),
                  }"
                  @click="
                    loadPreviewAndSelectThisMarketV2(
                      object.sport._id,
                      object.sport.id,
                      object.source,
                      object.tournament,
                      object.tournament.id,
                      market,
                      market.id,
                      index + 1,
                      null,
                      null,
                      false
                    )
                  "
                >
                  <span>
                    {{ getTranslatedMarketName(market) }}
                  </span>
                </v-btn>
              </div>
            </template>
            <template v-else>
              <div
                class="col-xs-6 col-sm-4 col-md-2 col-lg-2 col-xl-2 markets-button-container"
                v-for="(market, index) in getSpecifiersForTournament(
                  object.sport._id,
                  object.tournament
                ).slice(0, 12)"
                :key="'market_specifier_' + index"
              >
                <v-btn
                  tile
                  v-bind:class="{
                    'markets-odds-active': isThisMarketActiveForClass(
                      object.tournament.id,
                      market.id,
                      index
                    ),
                  }"
                  @click="
                    loadPreviewAndSelectThisMarketV2(
                      object.sport._id,
                      object.sport.id,
                      object.source,
                      object.tournament,
                      object.tournament.id,
                      market,
                      market.id,
                      index + 1,
                      null,
                      null,
                      false
                    )
                  "
                  class="btn_market"
                  :title="getTranslatedMarketName(market)"
                >
                  <span>
                    {{ getTranslatedMarketName(market) }}
                  </span>
                </v-btn>
              </div>
            </template>
          </v-col>
          <v-col
            cols="12"
            md="12"
            class="showMoreMarketsContainer"
            v-if="
              getSpecifiersForTournament(object.sport._id, object.tournament)
                .length > 12
            "
          >
            <div class="d-flex">
              <span style="margin-left: auto" @click="toggleShowLess(object)">
                <span class="d-flex" style="cursor: pointer; font-size: 12px">
                  {{ !showMore(object) ? $t('showMore') : $t('showLess') }}
                  <div>
                    <v-icon
                      v-if="!showMore(object)"
                      class="arrow-down"
                      style="
                        font-size: 14px;
                        padding-left: 6px;
                        padding-bottom: 4px;
                      "
                      >mdi-arrow-down</v-icon
                    >
                    <v-icon
                      v-else
                      class="arrow-up"
                      style="
                        font-size: 14px;
                        padding-left: 6px;
                        padding-bottom: 4px;
                      "
                      >mdi-arrow-up</v-icon
                    >
                  </div>
                </span>
              </span>
            </div>
          </v-col>
        </v-row>
        <div v-if="object.type == 'prematch'" class="tournament-card-events">
          <div v-if="object.events_sources.length > 0">
            <div
              v-for="(group, date) in groupByDate(object.events)"
              :key="'group_by_date_' + date"
            >
              <div class="bar-info" v-if="showMatchDataInRow === false">
                <v-col cols="12" sm="3" md="3" class="no-padding">
                  <span class="date">{{ date }}</span>
                </v-col>

                <v-col
                  cols="12"
                  sm="8"
                  md="8"
                  class="no-padding group-sign header-sign"
                >
                  <span
                    v-if="isMainMarketActive(object.tournament.id)"
                    class="sign-header"
                    v-for="(market, index) in visibleMarketsHeader(object)"
                    :key="'header_market_' + index"
                  >
                    <div class="market-group-name">
                      {{ market.marketName }}
                    </div>

                    <div class="market-sign-name-container">
                      <div
                        class="market-sign-name"
                        v-for="(outcome, index) in market.outcomeNames"
                        :key="'market_outcome_preview_' + index"
                      >
                        <span v-if="outcome == '-'">
                          <general-spread-selector
                            :tournamentId="object.tournament.id"
                            :marketId="market.marketId"
                            :specifiersList="market.specifiersList"
                          ></general-spread-selector>
                        </span>
                        <span
                          v-else
                          class="outcome-name"
                          :title="outcome"
                          style="cursor: pointer"
                        >
                          {{ outcome }}
                        </span>
                      </div>
                    </div>
                  </span>
                </v-col>
                <v-col cols="12" sm="1" md="1" class="no-padding"> </v-col>
              </div>

              <div
                v-for="(event, index) in group"
                :key="'event_preview_' + event.id"
              >
                <div
                  v-if="
                    new Date(event.scheduled).getTime() > new Date().getTime()
                  "
                  class="event"
                  :class="index % 2 == 0 ? 'even' : 'odd'"
                >
                  <v-col
                    cols="12"
                    sm="3"
                    md="3"
                    class="no-padding info-event"
                    @click="
                      getDetailOfEvent(
                        event.id,
                        event.type,
                        object.sport.id,
                        object.tournament.id ? object.tournament.id : '',
                        event.status,
                        event.time,
                        event.competitors.home.name,
                        event.competitors.away.name
                      )
                    "
                  >
                    <span
                      class="info-match"
                      :class="
                        showMatchDataInRow === true ? 'bar-info-in-odds' : ''
                      "
                    >
                      <span class="date" v-if="showMatchDataInRow === true">{{
                        formatDate(event.scheduled)
                      }}</span>
                      <span class="time">
                        {{
                          new Date(event.scheduled).toLocaleTimeString([], {
                            hour: '2-digit',
                            minute: '2-digit',
                          })
                        }}
                      </span>
                      <span
                        v-if="
                          getUserType == 4 ||
                          getCashier ||
                          !getSettings.enableQuickBetOnlyForAgency
                        "
                        class="event-qbet"
                        title="qbet"
                      >
                        {{ event.quickbet }}
                      </span>
                    </span>
                    <span class="competitors">
                      <span class="home">{{
                        event.competitors.home.name
                      }}</span>
                      <span class="away">{{
                        event.competitors.away.name
                      }}</span>
                    </span>
                  </v-col>

                  <v-col
                    cols="12"
                    sm="8"
                    md="8"
                    class="no-padding group-sign main-preview"
                    v-if="
                      isMainMarketActive(object.tournament.id) &&
                      getTypeOfViewForMarketActive(object.tournament.id) ==
                        'extended'
                    "
                  >
                    <div class="extended-odds-container">
                      <div
                        class="mainMarketContainer"
                        style="display: inline-flex; justify-content: flex-end"
                        v-for="(oddMarket, index) in visibleMarkets(event)"
                        :key="'mainMarketContainer_preview_' + index"
                      >
                        <template
                          v-if="
                            !oddMarket.void &&
                            oddMarket.selectView != null &&
                            oddMarket.selectView == true
                          "
                        >
                          <odd-with-spread
                            :odds="oddMarket"
                            :event="event"
                            :sport="object.sport"
                            :category="object.category"
                            :tournament="object.tournament"
                          ></odd-with-spread>
                        </template>

                        <div
                          v-if="
                            (!oddMarket.void && oddMarket.selectView == null) ||
                            oddMarket.selectView == false
                          "
                          class="extended no-padding"
                          v-for="(odd, index) in oddMarket.odds"
                          :key="'odd_in_oddMarket_preview_' + index"
                        >
                          <div
                            v-if="odd.outcome_odd_value > 1.0 && odd.active"
                            class="value extended-odd"
                            :class="[
                              'multi-' + oddMarket.multiplicity_min,
                              odd.type_change != undefined
                                ? odd.type_change
                                : 'equal',
                              getOddsSources.includes(odd.unique_id)
                                ? 'odd_selected'
                                : '',
                            ]"
                            @click="
                              putCart(
                                odd,
                                event,
                                object.sport,
                                object.category,
                                object.tournament
                              )
                            "
                          >
                            <div
                              class="extended_odd_value"
                              :class="[
                                classTriangleDownOdds(odd.type_change),
                                showOutcomeNameOnButton === true
                                  ? 'justify-space-between w-100 px-1'
                                  : '',
                              ]"
                            >
                              <!-- todo per gli special value devo tenere cmq il vecchio comortamento di illuminazione quando la quota cambia -->

                              <span
                                class="odd-outcome-name"
                                v-if="showOutcomeNameOnButton === true"
                                >{{ odd.outcome_name }}</span
                              >
                              <span class="odd-value">{{
                                odd.outcome_odd_value | odds_type_filter
                              }}</span>
                            </div>
                          </div>
                          <div
                            v-else
                            class="value extended-view-locked"
                            :class="'multi-' + oddMarket.multiplicity_min"
                          >
                            <div
                              class="extended_odd_value"
                              :class="classTriangleDownOdds(odd.type_change)"
                            >
                              <!-- todo per gli special value devo tenere cmq il vecchio comortamento di illuminazione quando la quota cambia -->
                              <v-icon dense>mdi-lock</v-icon>
                            </div>
                          </div>
                        </div>

                        <div
                          v-if="oddMarket.void"
                          class="odd"
                          v-for="n in oddMarket.n_outcomes"
                          :key="$uuid.v1()"
                        >
                          <div
                            class="value locked"
                            :class="'multi-' + oddMarket.multiplicity_min"
                          >
                            <v-icon dense>mdi-lock</v-icon>
                          </div>
                        </div>

                        <div></div>

                        <div
                          class="markets-group-separator"
                          v-if="+index + 1 < Object.keys(event.odds).length"
                        >
                          <v-divider vertical> </v-divider>
                        </div>
                      </div>
                    </div>
                  </v-col>

                  <v-col
                    v
                    cols="12"
                    sm="8"
                    md="8"
                    class="no-padding group-sign"
                    v-else
                  >
                    <div
                      class="extended-odds-container col-sm-12 col-md-12 col-lg-12 col-xl-12"
                      v-for="(oddMarket, index) in event.odds"
                      :key="'extendend_odd_container' + index"
                    >
                      <template
                        v-if="
                          !oddMarket.void &&
                          oddMarket.selectView != null &&
                          oddMarket.selectView == true
                        "
                      >
                        <odd-with-spread
                          :odds="oddMarket"
                          :event="event"
                          :sport="object.sport"
                          :category="object.category"
                          :tournament="object.tournament"
                        ></odd-with-spread>
                      </template>

                      <div
                        v-if="
                          (!oddMarket.void && oddMarket.selectView == null) ||
                          oddMarket.selectView == false
                        "
                        class="extended no-padding"
                        :class="
                          getSizeOddButtonForMarketActive(object.tournament.id)
                        "
                        v-for="(odd, index) in oddMarket.odds"
                        :key="
                          'odd_in_oddMarket_default_view_preview' +
                          odd.unique_id
                        "
                      >
                        <div
                          v-if="odd.outcome_odd_value > 1.0 && odd.active"
                          class="value extended-odd"
                          :class="[
                            'multi-' + oddMarket.multiplicity_min,
                            odd.type_change != undefined
                              ? odd.type_change
                              : 'equal',
                            getOddsSources.includes(odd.unique_id)
                              ? 'odd_selected'
                              : '',
                          ]"
                          @click="
                            putCart(
                              odd,
                              event,
                              object.sport,
                              object.category,
                              object.tournament
                            )
                          "
                        >
                          <div
                            class="extended_sign_value"
                            :class="classTriangleUpOdds(odd.type_change)"
                          >
                            <!--                                            {{ odd.outcome_name }} {{odd.specifier}}-->
                            {{ odd.outcome_name }}
                            {{ getSpread(odd.market_unique_id) }}
                          </div>
                          <div
                            class="extended_odd_value"
                            :class="classTriangleDownOdds(odd.type_change)"
                          >
                            <!-- todo per gli special value devo tenere cmq il vecchio comortamento di illuminazione quando la quota cambia -->
                            {{ odd.outcome_odd_value | odds_type_filter }}
                          </div>
                        </div>
                        <div
                          v-else
                          class="value extended-view-locked"
                          :class="'multi-' + oddMarket.multiplicity_min"
                        >
                          <div
                            class="extended_sign_value"
                            :class="classTriangleUpOdds(odd.type_change)"
                          >
                            {{ odd.outcome_name }}
                            {{ getSpread(odd.market_unique_id) }}
                          </div>
                          <div
                            class="extended_odd_value"
                            :class="classTriangleDownOdds(odd.type_change)"
                          >
                            <!-- todo per gli special value devo tenere cmq il vecchio comortamento di illuminazione quando la quota cambia -->
                            <v-icon dense>mdi-lock</v-icon>
                          </div>
                        </div>
                      </div>

                      <div
                        v-if="oddMarket.void"
                        class="odd"
                        v-for="n in oddMarket.n_outcomes"
                        :key="$uuid.v1()"
                      >
                        <div
                          class="value locked"
                          :class="'multi-' + oddMarket.multiplicity_min"
                        >
                          <v-icon dense>mdi-lock</v-icon>
                        </div>
                      </div>
                    </div>
                  </v-col>

                  <v-col cols="12" sm="1" md="1" class="no-padding group-sign">
                    <div class="odd">
                      <div
                        v-if="event.count_odds > 0"
                        class="value"
                        style="
                          width: 100% !important;
                          max-width: 100% !important;
                        "
                        @click="
                          getDetailOfEvent(
                            event.id,
                            event.type,
                            object.sport.id,
                            object.tournament.id ? object.tournament.id : '',
                            event.status,
                            event.time,
                            event.competitors.home.name,
                            event.competitors.away.name
                          )
                        "
                        v-bind:class="{
                          'detail-opened': getEventsDetailActive.includes(
                            event.id
                          ),
                        }"
                      >
                        <span v-if="getOddsType == 'decimal'"
                          >+ {{ event.count_odds }}</span
                        >
                        <span v-if="getOddsType == 'american'">{{
                          $t('moreBets')
                        }}</span>
                      </div>
                      <div v-else class="value locked">
                        <v-icon dense>mdi-lock</v-icon>
                      </div>
                    </div>
                  </v-col>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div
              cols="12"
              class="tournament-card-events info-event event no-event"
            >
              <div class="message" align="center">
                <span class="title">{{ $t('noevent') }}</span>
                <br />
                <span class="subTitle">{{ $t('pleaseSelectOdd') }}</span>
              </div>
            </div>
          </div>
        </div>

        <div
          v-else-if="object.type == 'antepost'"
          class="tournament-card-events"
        >
          <div
            v-for="(oddMarket, index) in object.events.odds"
            class="antepost-event"
            v-if="oddMarket.odds.length > 0"
            :key="$uuid.v1()"
          >
            <div class="bar-info">
              <v-col
                cols="12"
                md="12"
                class="no-padding"
                :title="oddMarket.name_market"
              >
                <span class="date">
                  {{ oddMarket.name_market }}
                </span>
              </v-col>
            </div>

            <v-row class="antepost-group-sign no-padding no-margin">
              <v-col
                cols="12"
                md="4"
                v-if="!oddMarket.void"
                class="odd-antepost"
                :class="[
                  getOddsSources.includes(odd.unique_id) ? 'odd_selected' : '',
                ]"
                v-for="(odd, index) in oddMarket.odds"
                :key="$uuid.v1()"
                :title="odd.outcome_name + ' - ' + oddMarket.name_market"
                @click="
                  putCart(
                    odd,
                    object.events,
                    object.sport,
                    object.category,
                    object.tournament
                  )
                "
              >
                <div class="outcome-name">
                  {{ odd.outcome_name }}
                </div>
                <div
                  v-if="odd.outcome_odd_value > 1.0"
                  class="value"
                  :class="'multi-' + oddMarket.multiplicity_min"
                >
                  {{ odd.outcome_odd_value | odds_type_filter }}
                </div>
                <div
                  v-else
                  class="value"
                  :class="'multi-' + oddMarket.multiplicity_min"
                >
                  <v-icon dense>mdi-lock</v-icon>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-card>
    </transition-group>
    <transition-group
      v-else-if="checkIsMobile() || (checkIsTablet() && getPreview.length > 0)"
      name="card-in-out"
      v-show="!getMobileCartOpen && !getProgramOpen"
    >
      <v-card
        class="tournament-card-preview preview-mobile"
        elevation="1"
        v-for="(object, index) in getPreview"
        :key="'getPreviewMobile_' + index"
      >
        <div class="progress-line-container">
          <v-progress-linear
            indeterminate
            color="primary darken-2"
            v-if="checkIfIsLoading(object)"
          >
          </v-progress-linear>
        </div>

        <tournament-breadcrumb
          :object="object"
          :sport-path="sportPath"
          :category-path="categoryPath"
          :light="light"
          :breadcrumb-type="breadcrumbPrematchType"
          @remove-preview="removePreview"
        />

        <!--                <div class="tournament-card-header">-->
        <!--                  <span class="sport-text" :title="object.sport.name">-->
        <!--                    <img v-if="object.sport.name.includes('Antepost')" :src="sportPath+'antepost.svg'"-->
        <!--                         :alt="'Antepost'+object.sport.name">-->
        <!--                    <img v-else :src="sportPath+object.sport.id+'.svg'" :alt="object.sport.name"-->
        <!--                         v-bind:class="{'img-sport-light': (light)}">-->
        <!--                      &lt;!&ndash;            {{ object.sport.name }}&ndash;&gt;-->
        <!--                  </span>-->
        <!--                    <span class="category-text" :title="object.category.name" @click="openLateralMenu">-->
        <!--    &lt;!&ndash;            <v-icon dense>mdi-chevron-right</v-icon>&ndash;&gt;-->
        <!--                     <img :src="categoryPath+object.category.id+'.svg'" :alt="object.category.name">-->
        <!--                                    {{ object.category.name }}-->
        <!--                    </span>-->
        <!--                    <v-icon dense>mdi-chevron-right</v-icon>-->
        <!--                    <span v-if="object.type == 'prematch'" class="tournament-text highlight"-->
        <!--                          :title="object.tournament.name">-->
        <!--                        &lt;!&ndash;            <v-icon dense>mdi-chevron-right</v-icon>&ndash;&gt;-->
        <!--                    {{ object.tournament.name }}-->
        <!--                    </span>-->
        <!--                    <span v-else-if="object.type == 'antepost'" class="tournament-text highlight"-->
        <!--                          :title="object.desc.name">-->
        <!--                        <v-icon dense>mdi-chevron-right</v-icon>-->
        <!--                        {{ object.desc.name }}-->
        <!--                    </span>-->
        <!--                    <span class="close-card cursor-pointer" @click="removePreview(object)">-->
        <!--                        <svg width="14"-->
        <!--                                         height="14"-->
        <!--                                         viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">-->
        <!--                                         <path d="M10.7699 1.33324L6.99991 5.11324L3.22991 1.33324C2.9784 1.08173 2.63727 0.94043 2.28158 0.94043C1.92588 0.94043 1.58476 1.08173 1.33324 1.33324C1.08173 1.58476 0.94043 1.92588 0.94043 2.28158C0.94043 2.63727 1.08173 2.9784 1.33324 3.22991L5.11324 6.99991L1.33324 10.7699C1.08173 11.0214 0.94043 11.3625 0.94043 11.7182C0.94043 12.0739 1.08173 12.4151 1.33324 12.6666C1.58476 12.9181 1.92588 13.0594 2.28158 13.0594C2.63727 13.0594 2.9784 12.9181 3.22991 12.6666L6.99991 8.88658L10.7699 12.6666C11.0214 12.9181 11.3625 13.0594 11.7182 13.0594C12.0739 13.0594 12.4151 12.9181 12.6666 12.6666C12.9181 12.4151 13.0594 12.0739 13.0594 11.7182C13.0594 11.3625 12.9181 11.0214 12.6666 10.7699L8.88658 6.99991L12.6666 3.22991C12.7911 3.10537 12.8899 2.95753 12.9573 2.79481C13.0247 2.63209 13.0594 2.4577 13.0594 2.28158C13.0594 2.10545 13.0247 1.93106 12.9573 1.76834C12.8899 1.60563 12.7911 1.45778 12.6666 1.33324C12.542 1.20871 12.3942 1.10992 12.2315 1.04252C12.0688 0.97512 11.8944 0.94043 11.7182 0.94043C11.3625 0.94043 11.0214 1.08173 10.7699 1.33324Z"/>-->
        <!--                        </svg>-->
        <!--                    </span>-->
        <!--                </div>-->

        <v-row
          class="no-padding no-margin"
          v-if="getGroupMarketsForCategory(object).length > 0"
        >
          <v-col cols="12" id="container_group_markets_odds_mobile">
            <v-col
              class="marketGroupContainer"
              cols="4"
              v-for="(marketGroup, index) in getGroupMarketsForCategory(object)"
              :key="'market_group_' + index"
            >
              <v-btn
                small
                tile
                class="marketGroup"
                :class="
                  marketGroup._id === getMarketGroupActive(object)
                    ? 'group-odds-active'
                    : ''
                "
                depressed
                block
                @click="
                  showMarketForThisMarketGroup(object, marketGroup, index)
                "
              >
                <span class="text-sport text-capitalize">
                  {{ getTranslatedGroupMarket(marketGroup) }}</span
                >
              </v-btn>
            </v-col>
          </v-col>
          <!-- todo add here a class when the full screen personalization is active -->
          <v-col
            cols="12"
            class="market-navigation-container"
            style="display: block"
          >
            <!--                        <market-navigation-drawer :key="object.tournament.id + 'k_'+ market_nav_mobile_key"-->
            <!--                                                  :marketsList="getSpecifiersForTournament(object.sport._id, object.tournament)"-->
            <!--                                                  :sportCategoryTournamentInfo="object"></market-navigation-drawer>-->

            <market-navigation-drawer-modal
              :key="object.tournament.id + 'k_' + market_nav_mobile_key"
              :marketsList="
                getSpecifiersForTournament(object.sport._id, object.tournament)
              "
              :sportCategoryTournamentInfo="object"
            >
            </market-navigation-drawer-modal>

            <div class="activeGroupMarketInfo" style="position: absolute">
              <span>{{
                getGroupNameActiveForTournament(object.tournament)
              }}</span>
              <span> <v-icon dense>mdi-chevron-right</v-icon></span>
              <span>{{
                getActiveMarketNameForTournament(object.tournament)
              }}</span>
            </div>
          </v-col>
        </v-row>

        <div
          v-if="object.type == 'prematch'"
          class="tournament-card-events"
          v-for="(group, date) in groupByDate(object.events)"
          :key="'group_by_date_mobile_' + date + '_adjust_key_' + adjust"
        >
          <div class="bar-info">
            <v-col xs="6" class="no-padding">
              <span class="date">{{ date }}</span>
            </v-col>

            <v-col
              xs="6"
              class="no-padding group-sign"
              v-if="
                object.headerSign[0] != null &&
                !isMainMarketActive(object.tournament.id) &&
                object.headerSign[0].sizeForView <= +3
              "
            >
              <template
                v-if="
                  !isMainMarketActive(object.tournament.id) &&
                  object.headerSign[0].sizeForView <= +3
                "
              >
                <template
                  v-for="(outcome, index_mrk) in object.headerSign[0]
                    .outcomeNames"
                >
                  <template v-if="outcome == '-'">
                    <span class="sign">{{ $t('spread') }}</span>
                  </template>
                  <template v-else>
                    <span class="sign">{{ outcome }} </span>
                  </template>
                </template>
              </template>
            </v-col>

            <v-col
              v-else
              xs="6"
              class="no-padding group-sign"
              @click="hideEventsInGroupDate('group_events_' + date)"
            >
              <span class="hide-events-in-group-date">
                <v-icon
                  v-if="areOpenEventsInGroupDate('group_events_' + date)"
                  dense
                  class="toggle-event-arrow"
                  style="font-size: 16px"
                  >mdi-chevron-down
                </v-icon>
                <v-icon
                  v-else
                  dense
                  class="toggle-event-arrow"
                  style="font-size: 16px"
                  >mdi-chevron-up
                </v-icon>
              </span>
            </v-col>
          </div>

          <div
            :ref="'group_events_' + date"
            :key="'container_event_preview_mobile_by_group_date' + date"
          >
            <!-- TODO check the key on for cycle -->
            <div
              v-for="(event, index) in group"
              :key="'event_preview_mobile' + event.id"
            >
              <div
                class="event"
                v-if="
                  new Date(event.scheduled).getTime() > new Date().getTime()
                "
                :class="index % 2 == 0 ? 'even' : 'odd'"
              >
                <v-row class="event-preview-mobile">
                  <template
                    v-if="
                      event.odds[0].selectView != null &&
                      event.odds[0].selectView === true &&
                      event.odds[0].outcomeNumbersForSpread <= +2
                    "
                  >
                    <v-col
                      cols="6"
                      class="competitorsAndDate"
                      @click="
                        getDetailOfEvent(
                          event.id,
                          event.type,
                          object.sport.id,
                          object.tournament.id ? object.tournament.id : '',
                          event.status,
                          event.competitors.home.name,
                          event.competitors.away.name
                        )
                      "
                    >
                      <span class="competitors">
                        <span class="home">{{
                          event.competitors.home.name
                        }}</span>
                        <span class="away">{{
                          event.competitors.away.name
                        }}</span>
                        <span class="time">
                          <!--                             <v-icon x-small>mdi-timer</v-icon> {{new Date(event.scheduled).toLocaleTimeString([], {hour: '2-digit', minute: '2-digit'}) }}-->
                          {{
                            new Date(event.scheduled).toLocaleTimeString([], {
                              hour: '2-digit',
                              minute: '2-digit',
                            })
                          }}
                          <span style="padding-left: 10px"
                            >{{ $t('all') }}
                            <v-icon
                              class="open-detail-event-arrow"
                              dense
                              style="font-size: 12px"
                              >mdi-chevron-right</v-icon
                            ></span
                          >
                        </span>
                      </span>
                    </v-col>

                    <v-col cols="6" class="oddsColumn">
                      <div
                        class="no-padding group-sign"
                        v-for="(oddMarket, index) in event.odds"
                        :key="'events_odds_mobile_' + index"
                      >
                        <div
                          class="extended-odds-container-mobile"
                          v-if="
                            !oddMarket.void &&
                            oddMarket.selectView != null &&
                            oddMarket.selectView == true
                          "
                        >
                          <odd-with-spread
                            :odds="oddMarket"
                            :event="event"
                            :sport="object.sport"
                            :category="object.category"
                            :tournament="object.tournament"
                            :key="
                              'odd-with-spread-mobile-' +
                              event.id +
                              '-' +
                              oddMarket.id_market
                            "
                          ></odd-with-spread>
                        </div>

                        <div
                          v-if="oddMarket.void"
                          class="odd"
                          v-for="n in oddMarket.n_outcomes"
                          :key="'odd_mobile_locked'"
                        >
                          <div
                            class="value locked"
                            :class="'multi-' + oddMarket.multiplicity_min"
                          >
                            <v-icon dense>mdi-lock</v-icon>
                          </div>
                        </div>
                      </div>
                    </v-col>
                  </template>
                  <template v-else-if="event.odds[0].odds_count_market <= +3">
                    <v-col
                      cols="6"
                      class="competitorsAndDate"
                      @click="
                        getDetailOfEvent(
                          event.id,
                          event.type,
                          object.sport.id,
                          object.tournament.id ? object.tournament.id : '',
                          event.status,
                          event.competitors.home.name,
                          event.competitors.away.name
                        )
                      "
                    >
                      <span class="competitors">
                        <span class="home">{{
                          event.competitors.home.name
                        }}</span>
                        <span class="away">{{
                          event.competitors.away.name
                        }}</span>
                        <span class="time">
                          <!--                             <v-icon x-small>mdi-timer</v-icon> {{new Date(event.scheduled).toLocaleTimeString([], {hour: '2-digit', minute: '2-digit'}) }}-->
                          {{
                            new Date(event.scheduled).toLocaleTimeString([], {
                              hour: '2-digit',
                              minute: '2-digit',
                            })
                          }}
                          <span style="padding-left: 10px"
                            >{{ $t('all') }}
                            <v-icon
                              dense
                              class="open-detail-event-arrow"
                              style="font-size: 12px"
                              >mdi-chevron-right</v-icon
                            ></span
                          >
                        </span>
                      </span>
                    </v-col>

                    <v-col cols="6" class="oddsColumn">
                      <div
                        class="no-padding group-sign"
                        v-for="(oddMarket, index) in event.odds"
                        :key="'events_odds_mobile_' + index"
                      >
                        <div
                          v-if="!oddMarket.void"
                          class="odd"
                          v-for="(odd, index) in oddMarket.odds"
                          :key="'odd_market_odds_mobile_' + index"
                        >
                          <div
                            v-if="odd.outcome_odd_value > 1.0 && odd.active"
                            class="value"
                            :class="[
                              'multi-' + oddMarket.multiplicity_min,
                              getOddsSources.includes(odd.unique_id)
                                ? 'odd_selected'
                                : '',
                            ]"
                            @click="
                              putCart(
                                odd,
                                event,
                                object.sport,
                                object.category,
                                object.tournament
                              )
                            "
                          >
                            <div
                              :class="[
                                odd.type_change != undefined
                                  ? odd.type_change
                                  : 'equal',
                              ]"
                            ></div>
                            {{ odd.outcome_odd_value | odds_type_filter }}
                          </div>
                          <div
                            v-else
                            class="value"
                            :class="'multi-' + oddMarket.multiplicity_min"
                          >
                            <v-icon dense>mdi-lock</v-icon>
                          </div>
                        </div>

                        <div
                          v-if="oddMarket.void"
                          class="odd"
                          v-for="n in oddMarket.n_outcomes"
                          :key="'odd_mobile_locked'"
                        >
                          <div
                            class="value locked"
                            :class="'multi-' + oddMarket.multiplicity_min"
                          >
                            <v-icon dense>mdi-lock</v-icon>
                          </div>
                        </div>
                      </div>
                    </v-col>
                  </template>

                  <template v-else>
                    <v-col
                      cols="12"
                      class="competitorsAndDate"
                      style="padding: 6px !important"
                      @click="
                        getDetailOfEvent(
                          event.id,
                          event.type,
                          object.sport.id,
                          object.tournament.id ? object.tournament.id : '',
                          event.status,
                          event.competitors.home.name,
                          event.competitors.away.name
                        )
                      "
                    >
                      <span
                        class="competitors"
                        style="padding-top: 4px; padding-bottom: 4px"
                      >
                        <span class="name_of_competitors" style="display: flex">
                          <span class="home">{{
                            event.competitors.home.name
                          }}</span>
                          <span class="separator" style="padding-left: 10px"
                            >-</span
                          >
                          <span class="away" style="padding-left: 10px">{{
                            event.competitors.away.name
                          }}</span>
                        </span>

                        <span class="time">
                          <!--                             <v-icon x-small>mdi-timer</v-icon> {{new Date(event.scheduled).toLocaleTimeString([], {hour: '2-digit', minute: '2-digit'}) }}-->
                          {{
                            new Date(event.scheduled).toLocaleTimeString([], {
                              hour: '2-digit',
                              minute: '2-digit',
                            })
                          }}
                          <span style="padding-left: 10px"
                            >{{ $t('all') }}
                            <v-icon
                              dense
                              class="open-detail-event-arrow"
                              style="font-size: 12px"
                              >mdi-chevron-right</v-icon
                            ></span
                          >
                        </span>
                      </span>
                    </v-col>

                    <v-col cols="12" class="listOdds">
                      <template
                        style="display: flex"
                        v-for="(oddMarket, index) in event.odds"
                      >
                        <template
                          v-if="!oddMarket.void"
                          class="odd"
                          v-for="(odd, index) in oddMarket.odds"
                          style="display: flex"
                        >
                          <div class="btn-multi-odds">
                            <v-col
                              cols="12"
                              v-if="odd.outcome_odd_value > 1.0 && odd.active"
                              class="value single-odd"
                              :class="[
                                'multi-' + oddMarket.multiplicity_min,
                                getOddsSources.includes(odd.unique_id)
                                  ? 'odd_selected'
                                  : '',
                              ]"
                              @click="
                                putCart(
                                  odd,
                                  event,
                                  object.sport,
                                  object.category,
                                  object.tournament
                                )
                              "
                            >
                              <v-col cols="12" class="odd-outcome-name">
                                {{ odd.outcome_name }}
                                {{
                                  odd.specifier != null && odd.specifier != ''
                                    ? '(' + odd.specifier + ')'
                                    : ''
                                }}
                              </v-col>
                              <v-col
                                cols="12"
                                class="odd-outcome-value"
                                style="padding: 0px"
                              >
                                {{ odd.outcome_odd_value | odds_type_filter }}
                              </v-col>
                            </v-col>

                            <v-col cols="12" v-else class="value single-odd">
                              <v-col cols="12" class="odd-outcome-name">
                                {{ odd.outcome_name }}
                                {{
                                  odd.specifier != null && odd.specifier != ''
                                    ? '(' + odd.specifier + ')'
                                    : ''
                                }}
                              </v-col>
                              <v-col cols="12" class="odd-outcome-value">
                                <v-icon dense>mdi-lock</v-icon>
                              </v-col>
                            </v-col>
                          </div>
                        </template>
                        <div
                          v-if="oddMarket.void"
                          class="odd"
                          v-for="n in oddMarket.n_outcomes"
                          :key="'odd_mobile_locked'"
                        >
                          <div
                            class="value locked"
                            :class="'multi-' + oddMarket.multiplicity_min"
                          >
                            <v-icon dense>mdi-lock</v-icon>
                          </div>
                        </div>
                      </template>
                    </v-col>
                  </template>
                </v-row>
              </div>
            </div>
          </div>
        </div>
      </v-card>
    </transition-group>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { isMobileOnly, isTablet } from 'mobile-device-detect'
import filter from 'lodash/filter'
import GeneralSpreadSelector from './spreadSelectors/GeneralSpreadSelector'
import MarketNavigationDrawer from './marketNavigationDrawer/MarketNavigationDrawer'
import MarketNavigationDrawerModal from './marketNavigationDrawer/MarketNavigationDrawerModal'
import {
  checkIsMobileDevice,
  checkIsTabletDevice,
} from '@/plugins/device-inspector'
import _ from 'lodash'

const OddWithSpread = () => ({
  component: import('@/components/center_widgets/Previews/OddWithSpread'),
})
const TournamentBreadcrumb = () => ({
  component: import(
    '@/components/center_widgets/Previews/TournamentBreadcrumb'
  ),
})

export default {
  name: 'MarketView',
  components: {
    OddWithSpread,
    GeneralSpreadSelector,
    MarketNavigationDrawer,
    MarketNavigationDrawerModal,
    TournamentBreadcrumb,
  },
  data: () => ({
    isMobileOnly: isMobileOnly,
    isTablet: isTablet,
    attrs: {
      class: 'mb-6',
      boilerplate: true,
      elevation: 2,
    },
    loading: false,
    loading_preview: [],
    antepostType: ['stage', 'season', 'simple_tournament'],
    categoryPath:
      process.env.VUE_APP_URL_CLOUDFRONT +
      '/svg/categories/rectangular_flags_category/',
    // sportPath: process.env.VUE_APP_URL_CLOUDFRONT + '/sport-images/icons/',
    // sportPath: process.env.VUE_APP_URL_CLOUDFRONT + '/svg/sports/light/',
    sportPath: process.env.VUE_APP_URL_CLOUDFRONT + '/svg/sports/icons/',
    light: window.icons == 'light' ? true : false,
    adjust: 1,
    sportId: window.sportId != null ? window.sportId : null,
    tournamentId: window.tournamentId != null ? window.tournamentId : null,
    eventId: window.eventId != null ? window.eventId : null,
    sportName: window.sportName != null ? window.sportName : null,
    tournamentName:
      window.tournamentName != null ? window.tournamentName : null,
    market_nav_mobile_key: 1,
    screenWidth: window.innerWidth,
  }),
  computed: {
    ...mapGetters({
      getLanguage: 'settings/getLanguage',
      getPreview: 'odds/getPreview',
      getEventsDetailActive: 'odds/getEventsDetailActive',
      getOddsSources: 'cart/getOddsSources',
      getPlatformId: 'settings/getPlatformId',
      getUserType: 'user/getType',
      getCashier: 'user/getCashier',
      getSettings: 'cart/getSettings',
      getConfiguredGroupsMarkets: 'odds/getConfiguredGroupsMarkets',
      getMarketsGroupsIdActive: 'odds/getMarketsGroupsIdActive',
      getMarketsIdActive: 'odds/getMarketsIdActive',
      getPreviewTabsSelectedForTournament:
        'odds/getPreviewTabsSelectedForTournament',
      getSpreadActivePreviewPrematch:
        'marketview/getSpreadActivePreviewPrematch',
      getSpreadsListPreviewPrematch: 'marketview/getSpreadsListPreviewPrematch',
      getGeneralSpreadActivePreviewPrematch:
        'marketview/getGeneralSpreadActivePreviewPrematch',
      getShowMoreMarketsPreview: 'marketview/getShowMoreMarketsPreview',
      getPreviewMarketsEnabledForMobile:
        'marketview/getPreviewMarketsEnabledForMobile',
      getOddsType: 'odds/getOddsType',
      getMarketGroupsActiveForTournaments:
        'marketview/getMarketGroupsActiveForTournaments',
      getLoadingPreview: 'odds/getLoadingPreview',
      getMobileCartOpen: 'cart/getMobileCartOpen',
      getProgramOpen: 'settings/getProgramOpen',
      showMatchDataInRow: 'uiConfig/showMatchDataInRow',
      showOutcomeNameOnButton: 'uiConfig/showOutcomeNameOnButton',
      breadcrumbPrematchType: 'uiConfig/breadcrumbPrematchType',
      getUseMarketOddsGroupV2: 'uiConfig/marketsGroupLayout',
      hideMainButtonOnPrematchShowcase:
        'uiConfig/hideMainButtonOnPrematchShowcase',
    }),
  },
  async mounted() {
    console.log('[INFO] Last update: 13-06-2025 time 16:10', this.getPreview)

    window.addEventListener('resize', this.handleResize)

    const vm = this
    await this.getSettingsGroup()
    this.$root.$on('getOddsForMarket', function (info) {
      const market = {
        market: info.market,
        marketId: info.marketId,
        marketName: info.marketName,
      }
      vm.loadPreviewAndSelectThisMarketV2(
        info.object.sport._id,
        info.object.sport.id,
        info.object.source,
        info.object.tournament,
        info.object.tournament.id,
        market,
        info.marketId,
        1,
        info.marketName,
        null,
        true
      ) // todo fi index ?
      vm.adjust = vm.adjust + 1
    })

    this.$root.$on('openTournamentMarketViewPreview', function (info) {
      vm.fetchPreview({
        tournament: info.tournamentId,
        type: 'previewOdds',
        sportId: info.sportId,
        groupOddsWithSpreads: true,
        forceDefaultGameConsole: false,
        mobilePlatform: vm.checkIsMobile() || vm.checkIsTablet(),
        isVisitedTournamentFromLocalStorage: false,
        sportName: info.sportName,
        tournamentName: info.tournamentName,
        source: info.tournamentId + '#prematch',
      })
    })

    await this.openTournament()
  },
  methods: {
    ...mapActions({
      removeFromPreview: 'odds/removeFromPreview',
      fetchEventDetailV2: 'odds/fetchEventDetailV2',
      setLoadingPreview: 'odds/setLoadingPreview',
      addOddToCart: 'cart/addOddToCart',
      fetchSettingsGroupsMarket: 'odds/fetchSettingsGroupsMarket',
      fetchActiveMarketsForMobile: 'odds/fetchActiveMarketsForMobile',
      fetchPreview: 'odds/fetchPreview',
      fetchPreviewForMarket: 'odds/fetchPreviewForMarket',
      setLiveMode: 'odds/setLiveMode',
      removeFromTournamentActive: 'odds/removeFromTournamentActive',
      addOrUpdateIndexOfTabActiveForThisTournament:
        'odds/addOrUpdateIndexOfTabActiveForThisTournament',
      removeSpreadSelectedForThisTournamentPreviewPrematch:
        'marketview/removeSpreadSelectedForThisTournamentPreviewPrematch', // todo
      getSportFrom_IdSport: 'sport/getSportFrom_IdSport',
      toggleShowMoreMarketsForThisTournament:
        'marketview/toggleShowMoreMarketsForThisTournament',
      removeMarketGroupActive: 'marketview/removeMarketGroupActive',
    }),
    formatDate(inputDate) {
      const date = new Date(inputDate)
      return date.toLocaleDateString(navigator.language, {
        day: '2-digit',
        month: '2-digit',
        year: '2-digit',
      })
    },
    checkIsMobile() {
      return checkIsMobileDevice()
    },

    checkIsTablet() {
      return checkIsTabletDevice()
    },

    hideEventsInGroupDate(param) {
      this.$refs[param][0].style.display =
        this.$refs[param][0].style.display === 'none' ? '' : 'none'
      this.$forceUpdate()
    },
    areOpenEventsInGroupDate(param) {
      const areOpen =
        this.$refs[param] &&
        this.$refs[param].length > 0 &&
        this.$refs[param][0].style.display === 'none'
          ? false
          : true
      return areOpen
    },
    isDesktopDevice() {
      return !(this.checkIsMobile() || this.checkIsTablet())
    },
    async toggleShowLess(object) {
      await this.toggleShowMoreMarketsForThisTournament({
        tournamentId: object.tournament.id,
      })
    },
    showMore(object) {
      const tournamentId = object.tournament.id
      const getPreviewGroupMarketsShowMore = this.getShowMoreMarketsPreview

      const infoForThisTournament = getPreviewGroupMarketsShowMore.filter(
        infoTournament => {
          return infoTournament.tournamentId == tournamentId
        }
      )

      if (infoForThisTournament.length > 0) {
        return infoForThisTournament[0].showMore
      } else {
        return false
      }
    },
    setSpreadToAllEventsOfMarket(tournamentId, marketId, spread) {
      const payload = {
        marketId: marketId,
        tournamentId: tournamentId,
        spreadSelected: spread,
      }
      this.$store.commit(
        'marketview/UPDATE_SPREAD_SELECTED_FOR_MARKET_OF_THIS_TOURNAMENT_FOR_ALL_EVENTS_PREVIEW_PREMATCH',
        payload
      )
    },
    removePreview(object) {
      this.clearMarketGroupActive(object.tournament.id)
      this.clearMarketsActive(object.tournament.id)
      this.clearTabActiveInfoForTournament(object.tournament.id)
      this.clearSpreadsActiveInfoForTournament(object.tournament.id)
      this.clearSpreadsListPreviewPrematchForTournament(object.tournament.id)
      this.clearGeneralSpreadSelectorActive(object.tournament.id)
      this.removeMarketsActiveMobileForThisTournament(object.tournament.id)
      this.removeFromPreview({ source: object.source })
      const tournamentIdString = object.tournament.id.toString()

      window.parent.postMessage(
        {
          type: 'removeSlugs',
        },
        '*'
      )

      if (localStorage.getItem('visited-tournament-preview')) {
        const now = new Date().getTime()
        const previewTournamentVisited = localStorage.getItem(
          'visited-tournament-preview'
        )
        let previewTournamentVisitedArray = JSON.parse(previewTournamentVisited)

        previewTournamentVisitedArray = previewTournamentVisitedArray.filter(
          el => {
            return (
              el.expiryTimeJson > now && el.tournamentId != tournamentIdString
            )
          }
        )

        localStorage.setItem(
          'visited-tournament-preview',
          JSON.stringify(previewTournamentVisitedArray)
        )
        const tournament =
          previewTournamentVisitedArray.length > 0
            ? previewTournamentVisitedArray[
                previewTournamentVisitedArray.length - 1
              ]
            : null

        if (tournament != null) {
          window.parent.postMessage(
            {
              type: 'tournamentOpened',
              sportId: tournament.sportId,
              tournamentId: tournament.tournamentId,
              sportName: tournament.sportName,
              tournamentName: tournament.tournamentName,
            },
            '*'
          )
        }
      }
    },
    groupByDate(events) {
      const refactored = _.groupBy(events, 'day')
      return refactored
    },
    filterEventsWithoutOdds(events) {
      const filteredEvents = filter(events, function (eventToCheck) {
        return eventToCheck.odds != null
      })
      return filteredEvents
    },
    groupByDateAndFilterEventsWithoutOdds(events) {
      const eventsWithOdds = this.filterEventsWithoutOdds(events)
      const eventsGroupedByDate = this.groupByDate(eventsWithOdds)
      return eventsGroupedByDate
    },
    async getSettingsGroup() {
      if (this.getPreview != null && this.getPreview.length > 0) {
        if (this.isDesktopDevice()) {
          for (let i = 0; i < this.getPreview.length; i++) {
            //todo if desktop and refactor me

            this.setMarketIdActiveWithoutReplace(
              this.getPreview[i].tournament,
              { id: 'mainMarket' }
            ) //todo reuse function

            await this.fetchSettingsGroupsMarket({
              sport: this.getPreview[i].sport._id,
              product_id: 0,
              lang: this.getLanguage,
              type: 'groupOdds',
              platform: this.getPlatformId,
              sportId: this.getPreview[i].sport.id,
              categoryId: this.getPreview[i].category.id,
              tournamentId: this.getPreview[i].tournament.id,
            })

            setTimeout(
              () => this.selectFirstGroupMarket(this.getPreview[i]),
              100
            ) //todo fix this !!! avoid use timeout , use a variabile instead
          }
        } else {
          // mobile devices like smartphones and tablets

          for (let i = 0; i < this.getPreview.length; i++) {
            await this.fetchSettingsGroupsMarket({
              sport: this.getPreview[i].sport._id,
              product_id: 0,
              lang: this.getLanguage,
              type: 'groupOdds',
              platform: this.getPlatformId,
              sportId: this.getPreview[i].sport.id,
              categoryId: this.getPreview[i].category.id,
              tournamentId: this.getPreview[i].tournament.id,
            })

            setTimeout(
              () => this.selectFirstGroupMarket(this.getPreview[i], false),
              100
            ) //todo fix this !!! avoid use timeout , use a variabile instead

            this.setMarketIdActive(this.getPreview[i].tournament, {
              id: this.getPreview[i].headerSign[0].marketId,
              marketName: this.getPreview[i].headerSign[0].marketName,
            })
          }
        }
      }
    },
    async getDetailOfEvent(
      eventSource,
      type,
      sport,
      tournament,
      status,
      startEventTime,
      competitorHome,
      competitorAway
    ) {
      document.body.scrollIntoView({ behavior: 'smooth' })
      window.parent.postMessage(
        {
          type: 'scrollTop',
        },
        '*'
      )
      await this.setLoadingPreview({ status: true })
      await this.fetchEventDetailV2({
        source: eventSource,
        group: null,
        sport: sport,
        tournament: tournament,
        status: status,
        startEventTime: startEventTime,
        competitorHome: competitorHome,
        competitorAway: competitorAway,
      })
      await this.setLoadingPreview({ status: false })
    },
    async putCart(odd, event, sport, category, tournament) {
      if (odd.outcome_odd_value > 0 && odd.active) {
        await this.addOddToCart({
          odd: odd,
          event: event,
          sport: sport,
          category: category,
          tournament: tournament,
        })
        this.$root.$emit('forceUpdateSingleMultiple')
        this.$root.$emit('forceUpdateIntegral')
        this.$root.$emit('forceUpdateSystem')
      }
    },
    getSpecifiers(spec) {
      let result = ''

      if (spec.includes('#')) {
        const split = spec.split('#')
        if (split[1].includes(':')) {
          result = '(' + split[1] + ')'
        } else if (split[1].includes('(') && split[1].includes('.')) {
          result = ' [' + split[1] + '] '
        } else if (split[1] != '') {
          result = split[1]
        }

        if (_.size(split) > 2) {
          return result + ' ' + split[2]
        } else {
          return result
        }
      } else {
        return result
      }
    },
    async showPreviewForFirstMarket(object, group, index) {
      await this.addOrUpdateIndexOfTabActiveForThisTournament({
        tournamentId: object.tournament.id,
        index: 1,
        marketId: group.markets[0].id,
      })

      const groupMarketSelected = this.getGroupMarketActiveForTournament(
        object.tournament
      )

      if (group._id == groupMarketSelected.groupIdSelected) {
        return
      }

      const objIndex = this.getMarketsGroupsIdActive.findIndex(
        marketGroupInfo => marketGroupInfo.tournamentId == object.tournament.id
      )

      if (objIndex == -1) {
        const marketGroup = {
          tournamentId: object.tournament.id,
          tournamentName: object.tournament.name,
          groupIdSelected: group._id,
          groupNameSelected:
            group.name && group.name.length > 0 ? group.name[0].text : 'Group',
          indexOfGroupSelected: index,
        }
        this.$store.commit('odds/addMarketsGroupIdActive', marketGroup)
      } else {
        const marketGroup = this.getMarketsGroupsIdActive[objIndex]
        marketGroup.indexOfGroupSelected = index
        ;(marketGroup.groupIdSelected = group._id),
          (marketGroup.groupNameSelected =
            group.name && group.name.length > 0 ? group.name[0].text : 'Group'),
          this.$store.commit('odds/replaceMarketGroupIdActive', marketGroup)
      }

      if (index == 0) {
        this.clearMarketsActive(object.tournament.id)
        await this.loadDefaultPreview(object)
      } else {
        await this.loadPreviewV2(
          object.sport._id,
          object.sport.id,
          object.tournament.id,
          group.markets[0].id,
          object.source,
          null,
          groupMarketSelected
        )
        this.selectFirstMarket(object, group, index)
      }
    },
    async showMarketForThisMarketGroup(object, group, index) {
      this.$root.$emit('openMarketNavigationDrawer', true)

      await this.addOrUpdateIndexOfTabActiveForThisTournament({
        tournamentId: object.tournament.id,
        index: 1,
        marketId: group.markets[0].id,
      })

      const groupMarketSelected = this.getGroupMarketActiveForTournament(
        object.tournament
      )

      if (group._id == groupMarketSelected.groupIdSelected) {
        return
      }

      const objIndex = this.getMarketsGroupsIdActive.findIndex(
        marketGroupInfo => marketGroupInfo.tournamentId == object.tournament.id
      )

      if (objIndex == -1) {
        const marketGroup = {
          tournamentId: object.tournament.id,
          tournamentName: object.tournament.name,
          groupIdSelected: group._id,
          groupNameSelected:
            group.name && group.name.length > 0 ? group.name[0].text : 'Group',
          indexOfGroupSelected: index,
        }
        this.$store.commit('odds/addMarketsGroupIdActive', marketGroup)
      } else {
        const marketGroup = this.getMarketsGroupsIdActive[objIndex]
        marketGroup.indexOfGroupSelected = index
        ;(marketGroup.groupIdSelected = group._id),
          (marketGroup.groupNameSelected =
            group.name && group.name.length > 0 ? group.name[0].text : 'Group'),
          this.$store.commit('odds/replaceMarketGroupIdActive', marketGroup)
      }
      //todo reuse the code this method is a copy of another oone with this litlte difference
    },
    getTranslatedMarketName(market) {
      const vm = this
      let nameTranslated = market.name

      const marketFound = filter(market.detail, function (marketDetail) {
        return marketDetail.lang == vm.getLanguage
      })

      if (marketFound.length > 0) {
        nameTranslated = marketFound[0].text
      }

      return nameTranslated
    },
    getTranslatedGroupMarket(groupMarket) {
      const vm = this
      let translatedGroupMarket = groupMarket.nameText

      const marketNameFound = filter(groupMarket.name, function (name) {
        return name.lang == vm.getLanguage
      })

      if (marketNameFound.length > 0) {
        translatedGroupMarket = marketNameFound[0].text
      }
      return translatedGroupMarket
    },
    //@deprecated
    async loadPreview(
      object,
      market,
      groupOddsWithSpreads = false,
      groupMarketSelected = null
    ) {
      // todo pass groupMarketSelected everywhere
      const vm = this

      this.loading_preview.push(object.tournament.id)

      const sport = await this.getSportFrom_IdSport({ _id: object.sport._id })
      const sportId = sport.id

      await this.fetchPreviewForMarket({
        tournament: object.tournament.id,
        type: 'previewOdds',
        market: market.id,
        source: object.source,
        sportId: sportId, //todo change name,
        mobilePlatform: vm.checkIsMobile() || vm.checkIsTablet(), //todo understand what i need to pass to rocky api and change all these calls
        groupOddsWithSpreads: groupOddsWithSpreads,
        groupId:
          groupMarketSelected != null
            ? groupMarketSelected.groupIdSelected
            : null,
      })

      const previews_loading = filter(
        this.loading_preview,
        function (loadingPreview) {
          return loadingPreview != object.tournament.id
        }
      )

      this.loading_preview = previews_loading
    },
    async loadPreviewV2(
      sport_Id,
      sportId,
      tournamentId,
      marketId,
      source,
      groupOddsWithSpreads = false,
      groupMarketSelected = null
    ) {
      const vm = this

      this.loading_preview.push(tournamentId)

      await this.fetchPreviewForMarket({
        tournament: tournamentId,
        type: 'previewOdds',
        market: marketId,
        source: source,
        sportId: sportId, //todo change name,
        mobilePlatform: vm.checkIsMobile() || vm.checkIsTablet(), //todo understand what i need to pass to rocky api and change all these calls
        groupOddsWithSpreads: groupOddsWithSpreads,
        groupId:
          groupMarketSelected != null
            ? groupMarketSelected.groupIdSelected
            : null,
      })

      const previews_loading = filter(
        this.loading_preview,
        function (loadingPreview) {
          return loadingPreview != tournamentId
        }
      )

      this.loading_preview = previews_loading
    },
    //@deprecated
    async loadPreviewAndSelectThisMarket(object, market, index) {
      const groupMarketSelected = this.getGroupMarketActiveForTournament(
        object.tournament
      )

      await this.addOrUpdateIndexOfTabActiveForThisTournament({
        tournamentId: object.tournament.id,
        index: index,
        marketId: market.id,
      })

      if (this.getActiveMarketForTournament(object.tournament) == market.id) {
        return
      }
      await this.loadPreview(object, market, null, groupMarketSelected)

      this.setMarketIdActive(object.tournament, market)
    },
    async loadPreviewAndSelectThisMarketV2(
      sport_Id,
      sportId,
      source,
      tournament,
      tournamentId,
      market,
      marketId,
      index,
      marketName,
      forceGroupMarket = null,
      groupOddsWithSpreads = false
    ) {
      let groupMarketSelected = null

      if (forceGroupMarket == null) {
        groupMarketSelected = this.getGroupMarketActiveForTournament(tournament)
      } else {
        groupMarketSelected = forceGroupMarket
      }

      await this.addOrUpdateIndexOfTabActiveForThisTournament({
        tournamentId: tournamentId,
        index: index,
        marketId: marketId,
      })

      if (this.getActiveMarketForTournament(tournament) == marketId) {
        return
      }

      await this.loadPreviewV2(
        sport_Id,
        sportId,
        tournamentId,
        marketId,
        source,
        groupOddsWithSpreads,
        groupMarketSelected
      )

      this.setMarketIdActive(tournament, {
        id: marketId,
        marketName: market.marketName,
      })
    },
    async loadPreviewMobile(object, market) {
      const groupMarketSelected = this.getGroupMarketActiveForTournament(
        object.tournament
      )
      if (this.getActiveMarketForTournament(object.tournament) == market.id) {
        return
      }
      this.setMarketIdActive(object.tournament, market)
      await this.loadPreviewV2(
        object.sport._id,
        object.sport.id,
        object.tournament.id,
        market.id,
        object.source,
        true,
        groupMarketSelected
      )
    },
    setMarketIdActive(tournament, market) {
      const objIndex = this.getMarketsIdActive.findIndex(
        market => market.tournamentId == tournament.id
      )

      if (objIndex == -1) {
        const marketActive = {
          tournamentId: tournament.id,
          tournamentName: tournament.name,
          marketActive: market.id,
          marketName: market.marketName,
        }

        this.$store.commit('odds/addMarketIdActive', marketActive)
      } else {
        const marketActive = this.getMarketsIdActive[objIndex]
        marketActive.marketActive = market.id
        marketActive.marketName = market.marketName
        this.$store.commit('odds/replaceMarketIdActive', marketActive)
      }
    },

    setMarketIdActiveWithoutReplace(tournament, market) {
      // reuse function setMarketIdActive

      const objIndex = this.getMarketsIdActive.findIndex(
        market => market.tournamentId == tournament.id
      )

      if (objIndex == -1) {
        const marketActive = {
          tournamentId: tournament.id,
          tournamentName: tournament.name,
          marketActive: market.id,
          marketName: market.marketName,
        }
        this.$store.commit('odds/addMarketIdActive', marketActive)
      }
    },

    changeLiveMode(mode) {
      this.setLiveMode({ mode: mode })
    },

    getGroupMarketsForCategory(object) {
      // todo avoid use function on template render

      let specifiers = []
      const allGroupMarkets = this.getConfiguredGroupsMarkets
      const foundGroupMarket = filter(allGroupMarkets, function (groupMarket) {
        // TODO && groupMarket.sportId == object.sportId  && groupMarket.categoryId == object.categoryId
        return (
          groupMarket.sport_id == object.sport._id &&
          groupMarket.tournamentId == object.tournament.id
        )
      })

      if (foundGroupMarket != null && foundGroupMarket.length > 0) {
        specifiers = foundGroupMarket[0].data
      }
      return specifiers
    },

    selectFirstGroupMarket(object, setMarketActive = true) {
      const tournamentId = object.tournament.id
      const objIndex = this.getMarketsGroupsIdActive.findIndex(
        marketGroup => marketGroup.tournamentId == tournamentId
      )

      if (objIndex == -1) {
        const groupMarket = this.findFirstGroupMarket(
          object.sport._id,
          tournamentId
        )

        if (groupMarket != null) {
          //bug on field groupNameSelected: Cannot read properties of undefined (reading 'text')
          const marketGroup = {
            tournamentId: object.tournament.id,
            tournamentName: object.tournament.name,
            groupIdSelected: groupMarket._id,
            groupNameSelected:
              groupMarket.name && groupMarket.name.length > 0
                ? groupMarket.name[0].text
                : 'Group',
            indexOfGroupSelected: 0,
          }

          this.$store.commit('odds/addMarketsGroupIdActive', marketGroup)
          if (setMarketActive === true) {
            this.setMarketIdActive(object.tournament, { id: 'mainMarket' })
          }
        }
      }
    },
    findFirstGroupMarket(sportId, tournamentId) {
      const configuredGroups = this.getConfiguredGroupsMarkets

      const configuredGroupFound = filter(
        configuredGroups,
        function (groupMarket) {
          return (
            groupMarket.sport_id == sportId &&
            groupMarket.tournamentId == tournamentId
          )
        }
      )

      if (configuredGroupFound.length > 0) {
        return configuredGroupFound[0].data != null &&
          configuredGroupFound[0].data.length > 0
          ? configuredGroupFound[0].data[0]
          : null
      } else {
        return null
      }
    },
    findFirstGroupMarketId(sportId, tournamentId) {
      const configuredGroups = this.getConfiguredGroupsMarkets

      const configuredGroupFound = filter(
        configuredGroups,
        function (groupMarket) {
          return (
            groupMarket.sport_id == sportId &&
            groupMarket.tournamentId == tournamentId
          )
        }
      )

      if (configuredGroupFound.length > 0) {
        return configuredGroupFound[0].data != null &&
          configuredGroupFound[0].data.length > 0
          ? configuredGroupFound[0].data[0]._id
          : null
      } else {
        return null
      }
    },
    getMarketGroupActive(object) {
      const marketGroupIndexActive = this.getMarketsGroupsIdActive.findIndex(
        marketGroup => marketGroup.tournamentId == object.tournament.id
      )

      if (marketGroupIndexActive == -1) {
        return ''
      } else {
        return this.getMarketsGroupsIdActive[marketGroupIndexActive]
          .groupIdSelected
      }
    },

    getGroupMarketActiveForTournament(tournament) {
      let groupMarketActive = null

      const marketsGroupActives = this.getMarketsGroupsIdActive
      const marketGroupSelectedForThisTournament = filter(
        marketsGroupActives,
        function (groupMarket) {
          return groupMarket.tournamentId == tournament.id
        }
      )

      if (
        marketGroupSelectedForThisTournament != null &&
        marketGroupSelectedForThisTournament.length > 0
      ) {
        groupMarketActive = marketGroupSelectedForThisTournament[0]
      }

      return groupMarketActive
    },
    getGroupNameActiveForTournament(tournament) {
      const groupName = 'Preview'

      const groupMarketsInfo = this.getMarketGroupsActiveForTournaments

      const foundMarketGroup = groupMarketsInfo.find(marketG => {
        return marketG.tournamentId === tournament.id
      })

      const groupId =
        foundMarketGroup != null && foundMarketGroup.groupId != null
          ? foundMarketGroup.groupId
          : null

      if (groupId == null) {
        return groupName
      } else {
        const marketLegend = this.getConfiguredGroupsMarkets.find(config => {
          return config.tournamentId === tournament.id
        })

        const data = marketLegend.data.find(elem => {
          return elem._id === groupId
        })
        return data.name && data.name.length > 0
          ? data.name[0].text
          : data.nameText
        //return  data.nameText
      }
    },
    getSpecifiersForTournament(sport_id, tournament) {
      let specifiers = []
      const groupMarketActived =
        this.getGroupMarketActiveForTournament(tournament)

      if (groupMarketActived == null) {
        return specifiers
      }

      const groupMarkets = this.getConfiguredGroupsMarkets

      const marketGroupFound = filter(groupMarkets, function (groupMarket) {
        return (
          groupMarket.sport_id == sport_id &&
          groupMarket.tournamentId == tournament.id
        ) //todo there and also in other parts that i have changed the getconfiguredgroup markets, insert also the categoryid and sport id
      })

      if (marketGroupFound != null && marketGroupFound.length > 0) {
        const allSpecifiers = marketGroupFound[0].data
        const specifiersForThisGroup = filter(
          allSpecifiers,
          function (specifier) {
            return specifier._id == groupMarketActived.groupIdSelected //example "6082ff95244e2f3a0b91e465"
          }
        )

        if (specifiersForThisGroup.length > 0) {
          specifiers = specifiersForThisGroup[0].markets
        }
      }

      return specifiers
    },

    isFirstGroupSelected(tournamentID) {
      let isFirstGroupSelected = false
      const groupMarketsForTournament = filter(
        this.getMarketsGroupsIdActive,
        function (marketGroup) {
          return marketGroup.tournamentId == tournamentID
        }
      )

      if (groupMarketsForTournament.length > 0) {
        if (groupMarketsForTournament[0].indexOfGroupSelected == 0) {
          isFirstGroupSelected = true
        }
      }
      return isFirstGroupSelected
    },
    isMainMarketActive(tournamentId) {
      let isMainMarketActive = false

      const marketsActive = filter(
        this.getMarketsIdActive,
        function (marketActive) {
          return marketActive.tournamentId == tournamentId
        }
      )

      if (marketsActive.length > 0) {
        if (marketsActive[0].marketActive == 'mainMarket') {
          isMainMarketActive = true
        }
      }
      return isMainMarketActive
    },

    getActiveMarketObjectForTournament(tournament) {
      let activeMarket = null

      const allMarketsActive = this.getMarketsIdActive

      const marketActiveForThisTournament = filter(
        allMarketsActive,
        function (m) {
          return m.tournamentId == tournament.id
        }
      )

      if (marketActiveForThisTournament.length > 0) {
        activeMarket = marketActiveForThisTournament[0]
      }
      return activeMarket
    },
    getActiveMarketForTournament(tournament) {
      let activeMarket = null

      const allMarketsActive = this.getMarketsIdActive

      const marketActiveForThisTournament = filter(
        allMarketsActive,
        function (m) {
          return m.tournamentId == tournament.id
        }
      )

      if (marketActiveForThisTournament.length > 0) {
        activeMarket = marketActiveForThisTournament[0].marketActive
      }
      return activeMarket
    },
    getActiveMarketNameForTournament(tournament) {
      const activeMarket = this.getActiveMarketObjectForTournament(tournament)

      if (activeMarket != null) {
        return activeMarket.marketName != null
          ? activeMarket.marketName
          : 'NO_MARKET_NAME'
      } else {
        return 'NO_MARKET_NAME_2'
      }
    },
    selectFirstMarket(object, groupMarket, index = null) {
      let marketToSelect = groupMarket.markets[0].id

      if (index != null && index == 0) {
        // if is the first group market selected === main group market
        marketToSelect = 'mainMarket'
      }

      const objIndex = this.getMarketsIdActive.findIndex(
        marketsForTournament =>
          marketsForTournament.tournamentId == object.tournament.id
      )
      if (objIndex == -1) {
        const marketActive = {
          tournamentId: object.tournament.id,
          tournamentName: object.tournament.name,
          marketActive: marketToSelect,
        }
        this.$store.commit('odds/addMarketIdActive', marketActive)
      } else {
        const marketActive = this.getMarketsIdActive[objIndex]
        marketActive.marketActive = marketToSelect
        this.$store.commit('odds/replaceMarketIdActive', marketActive)
      }
    },
    clearMarketGroupActive(tournamentId) {
      const filtered_array = _.filter(
        this.getMarketsGroupsIdActive,
        function (marketGroup) {
          //todo can use filter like in other parts of this component == filter
          return marketGroup.tournamentId != tournamentId
        }
      )

      this.$store.commit('odds/setMarketsGroupsIdActive', filtered_array)

      this.removeMarketGroupActive({ tournamentId: tournamentId })
    },
    clearMarketsActive(tournamentId) {
      const filtered_array = _.filter(
        this.getMarketsIdActive,
        function (market) {
          //todo can use filter like in other parts of this component == filter
          return market.tournamentId != tournamentId
        }
      )
      this.$store.commit('odds/setMarketsIdActive', filtered_array)
    },
    checkIfIsLoading(object) {
      const isLoading = this.loading_preview.includes(object.tournament.id)
      return isLoading
    },
    async loadDefaultPreview(object) {
      await this.addOrUpdateIndexOfTabActiveForThisTournament({
        tournamentId: object.tournament.id,
        index: 0,
      })

      if (
        this.getActiveMarketForTournament(object.tournament) == 'mainMarket'
      ) {
        return
      }

      this.loading_preview.push(object.tournament.id)
      const sport = await this.getSportFrom_IdSport({ _id: object.sport._id })
      const sportId = sport.id

      await this.removeFromTournamentActive(object.source)

      await this.fetchPreview({
        tournament: object.tournament.id,
        type: 'previewOdds',
        source: object.source,
        mode: 'substitute',
        sportId: sportId,
        groupOddsWithSpreads: true,
      })

      const previews_loading = filter(
        this.loading_preview,
        function (loadingPreview) {
          return loadingPreview != object.tournament.id
        }
      )

      this.loading_preview = previews_loading

      this.setMarketIdActive(object.tournament, { id: 'mainMarket' })
    },
    classTriangleUpOdds(typeChange) {
      //todo fix when quote is selected
      // typeChange = 'up'
      let type = ''

      if (typeChange != null && typeChange == 'up') {
        type = 'triangle-up'
      }
      return type
    },
    classTriangleDownOdds(typeChange) {
      //todo fix when quote is selected
      // typeChange = 'down'
      let type = ''

      if (typeChange != null && typeChange == 'down') {
        type = 'triangle-down'
      }
      return type
    },
    getTypeOfViewForMarketActive(tournamentId) {
      const marketsGroupsIdActive = this.getMarketsGroupsIdActive

      const marketIndex = marketsGroupsIdActive.findIndex(marketGroupActive => {
        return marketGroupActive.tournamentId == tournamentId
      })

      if (marketIndex != -1) {
        return marketsGroupsIdActive[marketIndex].typeView != null
          ? marketsGroupsIdActive[marketIndex].typeView
          : 'extended' //todo this default need be taken from the service not there in view
      } else {
        return 'extended' //todo this default need be taken from the service not there in view
      }
    },
    getSizeOddButtonForMarketActive(tournamentId) {
      let sizeButtons = 'col-md-2 col-lg-2 col-xl-2'
      const marketsGroupsIdActive = this.getMarketsGroupsIdActive

      const marketIndex = marketsGroupsIdActive.findIndex(marketGroupActive => {
        return marketGroupActive.tournamentId == tournamentId
      })

      if (marketIndex != -1) {
        // todo refactor
        if (marketsGroupsIdActive[marketIndex].sizeOddsButtons != null) {
          sizeButtons =
            'col-' +
            marketsGroupsIdActive[marketIndex].sizeOddsButtons.sizeOddButtonMd +
            ' ' +
            'col-' +
            marketsGroupsIdActive[marketIndex].sizeOddsButtons.sizeOddButtonLg +
            ' ' +
            'col-' +
            marketsGroupsIdActive[marketIndex].sizeOddsButtons.sizeOddButtonXl
        }
      }

      return sizeButtons
    },
    getSpread(spec) {
      let result = ''

      if (spec.includes('#')) {
        const split = spec.split('#')
        if (split[1].includes(':')) {
          result = '(' + split[1] + ')'
        } else if (split[1].includes('(') && split[1].includes('.')) {
          result = ' [' + split[1] + '] '
        } else if (split[1] != '') {
          result = split[1]
        }

        if (_.size(split) > 2) {
          return result + ' ' + split[2]
        } else {
          return result
        }
      } else {
        return result
      }
    },
    findTabActive(tournamentId) {
      let ret_value = 0

      const tab_active_info = filter(
        this.getPreviewTabsSelectedForTournament,
        function (tab_active) {
          return tab_active.tournamentId == tournamentId
        }
      )

      if (tab_active_info.length > 0) {
        ret_value = tab_active_info[0].index
      }

      return ret_value
    },
    isThisMarketActive(tournamentId, marketId) {
      let isActive = false

      const tab_active_info = filter(
        this.getPreviewTabsSelectedForTournament,
        function (tab_active) {
          return tab_active.tournamentId == tournamentId
        }
      )

      if (
        tab_active_info.length > 0 &&
        tab_active_info[0].marketId == marketId
      ) {
        isActive = true
      }

      return isActive
    },
    isThisMarketActiveForClass(tournamentId, marketId, index) {
      let isActive = false

      const tab_active_info = filter(
        this.getPreviewTabsSelectedForTournament,
        function (tab_active) {
          return tab_active.tournamentId == tournamentId
        }
      )

      if (
        tab_active_info.length > 0 &&
        tab_active_info[0].marketId == marketId
      ) {
        isActive = true
      }

      if (
        this.hideMainButtonOnPrematchShowcase === true &&
        this.isMainMarketActive(tournamentId) &&
        index === 0
      ) {
        isActive = true
      }

      return isActive
    },
    isThisMarketMobileActive(tournamentId, marketId) {
      let isActive = false

      const market_active_info = filter(
        this.getMarketsIdActive,
        function (marketActive) {
          return marketActive.tournamentId == tournamentId
        }
      )

      if (
        market_active_info.length > 0 &&
        market_active_info[0].marketActive == marketId
      ) {
        isActive = true
      }
      return isActive
    },
    clearTabActiveInfoForTournament(tournamentId) {
      const filtered_array = _.filter(
        this.getPreviewTabsSelectedForTournament,
        function (tab_selected_info) {
          return tab_selected_info.tournamentId != tournamentId
        }
      )
      this.$store.commit(
        'odds/SET_PREVIEW_TAB_SELECTED_FOR_TOURNAMENT',
        filtered_array
      )
    },
    clearSpreadsActiveInfoForTournament(tournamentId) {
      const filtered_array = _.filter(
        this.getSpreadActivePreviewPrematch,
        function (spreadActiveInfo) {
          return spreadActiveInfo.tournamentId != tournamentId
        }
      )

      this.$store.commit(
        'marketview/SET_SPREAD_ACTIVE_PREVIEW_PREMATCH',
        filtered_array
      )
    },
    clearSpreadsListPreviewPrematchForTournament(tournamentId) {
      const filtered_array = _.filter(
        this.getSpreadsListPreviewPrematch,
        function (spreadListInfo) {
          return spreadListInfo.tournamentId != tournamentId
        }
      )

      this.$store.commit(
        'marketview/SET_SPREADS_LIST_PREVIEW_PREMATCH',
        filtered_array
      )
    },
    clearGeneralSpreadSelectorActive(tournamentId) {
      const generalSpreadsActive = this.getGeneralSpreadActivePreviewPrematch
      const filtered_array = _.filter(
        generalSpreadsActive,
        function (spreadListInfo) {
          return spreadListInfo.tournamentId != tournamentId
        }
      )

      this.$store.commit(
        'marketview/SET_GENERAL_SPREAD_ACTIVE_PREVIEW_PREMATCH',
        filtered_array
      )
    },
    removeMarketsActiveMobileForThisTournament(tournamentId) {
      const previewMarketsEnabledForMobile =
        this.getPreviewMarketsEnabledForMobile
      const filtered_array = _.filter(
        previewMarketsEnabledForMobile,
        function (marketEnabled) {
          return marketEnabled.tournamentId != tournamentId
        }
      )

      this.$store.commit(
        'marketview/SET_PREVIEW_MARKETS_ENABLED_FOR_MOBILE',
        filtered_array
      )
    },
    getMarketsEnabledForMobile(object) {
      const infoForThisTournament = _.filter(
        this.getPreviewMarketsEnabledForMobile,
        function (infoTournament) {
          return (
            infoTournament.sportId == object.sport.id &&
            infoTournament.tournamentId == object.tournament.id
          )
        }
      )

      if (infoForThisTournament != null && infoForThisTournament.length > 0) {
        return infoForThisTournament[0].data
      } else {
        return []
      }
    },
    openLateralMenu() {
      this.$root.$emit('open_sidebar_left')
    },

    async openTournament() {
      if (
        this.tournamentId &&
        this.sportId &&
        this.sportName &&
        this.tournamentName &&
        this.eventId == null
      ) {
        await this.fetchPreview({
          tournament: this.tournamentId,
          type: 'previewOdds',
          sportId: this.sportId,
          groupOddsWithSpreads: true,
          forceDefaultGameConsole: false,
          mobilePlatform: this.checkIsMobile() || this.checkIsTablet(),
          isVisitedTournamentFromLocalStorage: false,
          sportName: this.sportName,
          tournamentName: this.tournamentName,
          source: this.tournamentId + '#prematch',
        })

        try {
          let visitedTournaments =
            JSON.parse(localStorage.getItem('visited-tournament-preview')) || []

          if (!Array.isArray(visitedTournaments)) {
            visitedTournaments = []
          }

          visitedTournaments = visitedTournaments.filter(
            item =>
              item.sportId === this.sportId &&
              item.tournamentId === this.tournamentId
          )

          localStorage.setItem(
            'visited-tournament-preview',
            JSON.stringify(visitedTournaments)
          )
        } catch (error) {
          console.error(
            'Error while setting local storage visited-tournament-preview :',
            error
          )
        }
      }
    },

    visibleMarketsHeader(object) {
      // todo non chiamare se non in sezione principale
      if (this.screenWidth < 1024) {
        return object.headerSign.slice(0, 1)
      } else if (this.screenWidth < 1440) {
        return object.headerSign.slice(0, 2)
      } else if (this.screenWidth < 1920) {
        return object.headerSign.slice(0, 3)
      } else if (this.screenWidth < 2560) {
        return object.headerSign.slice(0, 4)
      } else {
        return object.headerSign.slice(0, 5)
      }
    },
    visibleMarkets(event) {
      const oddsArray = Object.values(event.odds)

      if (this.screenWidth < 1024) {
        return oddsArray.slice(0, 1)
      } else if (this.screenWidth < 1440) {
        return oddsArray.slice(0, 2)
      } else if (this.screenWidth < 1920) {
        return oddsArray.slice(0, 3)
      } else if (this.screenWidth < 2560) {
        return oddsArray.slice(0, 4)
      } else {
        return oddsArray.slice(0, 5)
      }
    },
    handleResize: _.debounce(function () {
      this.screenWidth = window.innerWidth
    }, 200), // 200ms debounce time
  },
  watch: {
    async getPreview(val) {
      if (val.length > 0) {
        await this.getSettingsGroup()
      }
    },
    getMarketsGroupsIdActive(newVal, oldVal) {
      this.market_nav_mobile_key = this.market_nav_mobile_key + 1
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)

    this.loading_preview = null

    this.$root.$off('getOddsForMarket', () => {
      //console.log('destroyed')
    })

    this.$root.$off('openTournamentMarketViewPreview', () => {
      //console.log('destroyed')
    })
  },
}
</script>

<style></style>
